<template>
<div class="text-center">
  <VCard class="pa-2">
    <v-autocomplete
      v-model="applyNo"
      :items="applyNoList"
      :item-title="item => `${item.projectTitle} - ${item.fieldB} - ${item.applyNo}`"
      item-value="applyNo"
      label="選擇憑證的申請單號"
      :loading="loading"
      @update:modelValue="updateApplyNo()"
      auto-select-first
      no-data-text="尚無可確認憑證的申請單"
    ></v-autocomplete>
  </VCard>
  <div v-if="applyNo">
    <div class="mt-2 text-center">
      <div v-if="loading">
        <v-skeleton-loader type="image"></v-skeleton-loader>
      </div>
      <div v-else>
        <v-img
          v-if="imageData.image&&imageData.contentType.includes('webp')"
          rounded="sm"
          draggable
          :src="imageData.image"
          :loading="loading"
          ref="imgRef"
          :width="!!imgHeightSize ? null : '100%'"
          :height="imgHeightSize"
          class="border-radius-sm"
          @load="onImgLoad"
          :style="imgStyle"
          @touchstart="onTouchStart"
          @touchmove="onTouchMove"
          @touchend="onTouchEnd"
        ></v-img>
        <div v-else-if="!isEmptyObject(imageData)&&!!imageData.contentType" class="text-center h-33 border-sm border-dashed rounded d-flex justify-center align-center" style="min-height:150px">
          這是個檔案喔
          <v-icon icon="tabler-file-smile"></v-icon>
          <a @click="getJwtBeforeRedirect(imageData.certFiles)" target="_blank">下載{{imageData.certFiles}}</a>
        </div>
      </div>
    </div>
    <div class="floating-icons">
      <transition-group name="float" tag="div">
        <div
          v-for="icon in floatingIcons"
          :key="icon.id"
          class="float-icon"
          :style="{ left: icon.left + '%' }"
        >
          <v-btn
            class="ma-2"
            :color="floatIcon.color"
            :icon="floatIcon.icon"
            variant="tonal"
          ></v-btn>
        </div>
      </transition-group>
    </div>
    <div class="text-center mt-2">
      <v-chip chip color="primary" v-if="!!imageData.scheduleTitle" class="mx-1 mb-1" >
        行程:{{imageData.scheduleTitle}}
      </v-chip>
      <v-chip chip color="primary" v-if="!!imageData.itemName" class="mx-1 mb-1" >
        項目:{{imageData.itemName}}
      </v-chip>
      <v-chip chip color="primary" v-if="allImageLength > 0" class="mx-1 mb-1" >
        目前第{{photoIndex+1}}張，此申請單總共{{allImageLength}}張憑證
      </v-chip>
    </div>
    <div class="text-center mt-2" v-if="!isEmptyObject(imageData)">
      <v-btn color="error" class="mx-4" :loading="loading" size="x-large" variant="tonal"  icon="tabler-thumb-down" @click="reject"></v-btn>
      <!-- <v-btn color="warning" class="mx-2" :loading="loading" size="x-large" variant="tonal" icon="tabler-question-mark" @click="confuse"></v-btn> -->
      <v-btn color="success" class="mx-4" :loading="loading" size="x-large" variant="tonal" icon="tabler-thumb-up" @click="approve"></v-btn>
    </div>
  </div>
</div>
</template>
<script setup lang="ts">
import {useDisplay} from 'vuetify'
import { ref, computed, onMounted } from 'vue'
import {isEmptyObject} from "@/utils/deUtil";

const {md, mdAndUp ,lgAndUp, height} = useDisplay()


definePage({
  meta: {
    action: 'manage',
    subject: 'PAYMENTVOUCHERCONFIRM',
  },
})  

const fileUrl = useStorage("drFsUrl").value;

const imgRef = ref<HTMLImageElement | null>(null)
const loading = ref(false)
const applyNo = ref(null)

const imgWidth = ref(0)
const imgHeight = ref(0)

const dragX = ref(0)
const dragY = ref(0)
const dragRot = ref(0)
const isDragging = ref(false)

const allImageLength = ref(0)

const photoIndex = ref(0)
const certiFiledList=ref<{
  applyNo:string,
  certFiles:string,
  itemId:string,
  itemName:string,
  prikey:string,
  scheduleId:string,
  scheduleTitle:string,
}[]>([])
let startX = 0
let startY = 0
const floatIcon=ref<{ icon:string,color:string}>({
  icon:'tabler-question-mark',color:'warning'
})
const floatingIcons = ref<{ id: number, left: number}[]>([])
let iconId = 0

const setImgStatusDefine ={
  approve:'Y',
  reject:'N',
  // confuse:'confuse'
}
const imageDataOrigin = {
  image:null,
  contentType:null,
  applyNo:"",
  certFiles:"",
  itemId:"",
  itemName:"",
  prikey:"",
  scheduleId:"",
  scheduleTitle:"",
}
const imageData = ref(JSON.parse(JSON.stringify(imageDataOrigin)))

const onImgLoad = () => {
  if (imgRef.value) {
    imgWidth.value = imgRef.value.naturalWidth
    imgHeight.value = imgRef.value.naturalHeight
  }
}

const imgHeightSize = computed(() => {
  if(mdAndUp.value) {
    if(imgWidth.value < imgHeight.value) {
      if((height.value-200) < imgHeight.value) {
        return (height.value - 300) + 'px'
      }
    }
  }
  return null
})

const applyNoList = ref([])

const schedule = ref({
  scheduleId: '1234567890',
  name: '行程名稱',
  itemType: 'fee',
  itemTypeName: '膳宿費',
})

const popSwal = (icon,title,text) => {
  if(icon=="success"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else if (icon=="error"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else{
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }
}


const popChangeApplyNoSwal = () => {
  if(certiFiledList.value.length >= photoIndex.value && certiFiledList.value.length > 0 || certiFiledList.value.length === 0){
    let text = certiFiledList.value.length === 0?'目前申請單沒有憑證了':'目前是申請單的最後一張憑證'
    $swal({
      title: `換張申請單?`,
      text: text,
      icon: 'warning',
      reverseButtons: true,
      showCancelButton: true,
      cancelButtonText: "取消",
      confirmButtonText: '換張申請單',
    }).then(async(result)=>{
      if(result.isConfirmed){
        await changeApplyNo()
      }
    })
  }
}

const updateApplyNo = async (index:null|number) => {
  loading.value=true
  photoIndex.value = 0
  const res = await getAllImageByApplyNo(applyNo.value)
  certiFiledList.value = res
  if(certiFiledList.value.length>0){
    await updatePhoto(0)
    allImageLength.value = certiFiledList.value.length
  }else{
    popChangeApplyNoSwal()
    allImageLength.value = 0
  }
  loading.value=false
}

const updatePhoto = async (index:null|number) => {
  if(certiFiledList.value.length===0){
    popSwal('error', "目前沒有憑證資料", "請稍後再試")
    return
  }
  let getPhotoWebpIndex = !!index ? index : 0
  Object.assign(imageData.value, certiFiledList.value[getPhotoWebpIndex])
  try {
    // 拿到 blob
    const { blobData, contentType, certiFiled } = await getPhotoWebp(`${certiFiledList.value[getPhotoWebpIndex].certFiles}.webp`)
    // 若已經有舊的圖片資源，要主動釋放掉
    if (imageData.value.image) {
      URL.revokeObjectURL(imageData.value.image)
    }
    // Blob 轉成瀏覽器可用的路徑
    Object.assign(imageData.value, {
      image: contentType.includes('webp') ? URL.createObjectURL(blobData) : '',
      contentType: contentType,
      certFiles: certiFiled.replace('.webp',''),
    })
  } catch (error) {
    popSwal('error', "照片取得失敗", error.message || "請稍後再試")
    console.error('Failed to load image:', error)
  }
}

const btnControl =  async(swipeStatus:string) => {
  loading.value=true
  const params = {
    prikey: imageData.value.prikey,
    status: setImgStatusDefine[swipeStatus]
  }
  floatIconAnimate(swipeStatus)
  await setImgStatus(params)
  photoIndex.value++
  if(certiFiledList.value.length > photoIndex.value){
    await updatePhoto(photoIndex.value)
  }else{
    if(imageData.value.image){
      URL.revokeObjectURL(imageData.value.image)
    }
    Object.assign(imageData.value, imageDataOrigin)
    popChangeApplyNoSwal()
  }
  
  loading.value=false
}

const reject = async() => {
  btnControl('reject')
}

const approve = async() => {
  btnControl('approve')
}

const changeApplyNo = async() => {
  const res = await getAllApplyNo()
  if(res.length>0){
    applyNo.value = res[0].applyNo
    await updateApplyNo(applyNo.value)
  }else{
    applyNo.value = null
    popSwal('warning', "目前沒有任何上傳的憑證申請單", "請稍後再試")
  }
}

const floatIconAnimate=(status:null|string)=>{
  let icon='tabler-question-mark'
  let color='warning'
  if(status==='approve'){
    icon='tabler-thumb-up'
    color='success'
  }else if(status==='confuse'){
    icon='tabler-question-mark'
    color='warning'
  }else if(status==='reject'){
    icon='tabler-thumb-down'
    color='error'
  }
  floatIcon.value.icon=icon
  floatIcon.value.color=color
  for (let i = 0; i < 5; i++) {
     floatingIcons.value.push({
       id: iconId++,
       left: 30 + Math.random() * 40 // 30%~70%寬度
     })
   }
   // 2 秒後自動移除
   setTimeout(() => {
    floatingIcons.value.splice(0, floatingIcons.value.length)
    loading.value=false
   }, 2000)
}

const onTouchStart = (e: TouchEvent) => {
  isDragging.value = true
  const touch = e.touches[0]
  startX = touch.clientX
  startY = touch.clientY
}
const onTouchMove = (e: TouchEvent) => {
  if (!isDragging.value) return
  const touch = e.touches[0]
  dragX.value = touch.clientX - startX
  dragY.value = 0
  dragRot.value = dragX.value / 10
  // 限制 dragX 的範圍，防止圖片超出容器
  const maxDragX = 100; // 最大位移
  const minDragX = -100; // 最小位移
  if (dragX.value > maxDragX) dragX.value = maxDragX;
  if (dragX.value < minDragX) dragX.value = minDragX;
}
const onTouchEnd = (e: TouchEvent) => {
  e.stopPropagation();
  isDragging.value = false
  if (dragX.value > 10) {
    approve()
  } else if (dragX.value < -10) {
    reject()
  }
  dragX.value = 0
  dragY.value = 0
  dragRot.value = 0
}
const imgStyle = computed(() => ({
  transition: isDragging.value ? 'none' : 'transform 0.3s',
  transform: `translateX(${dragX.value}px) rotate(${dragRot.value}deg)`
}))

// file download
const getJwtBeforeRedirect = async (fileId) => {
  // 打开新链接
  const url = await mapFileDownload(fileUrl, fileId)
  window.open(url, '_blank');
};

// ---API---

const getPhotoWebp = async (certiFiled: string): Promise<Blob> => {
  if(!certiFiled){
    popSwal('error', "照片FileId取得失敗", "請稍後再試")
    return
  }
  try {
    const response = await fetch(`/tca/file/${certiFiled}`, {
      method: 'GET',
    });
    const blobData = await response.blob();
    const contentType = response.headers.get('content-type');
    return { blobData, contentType, certiFiled };
    
  } catch (error: any) {
    popSwal('error', "getPhotoWebp照片取得失敗", error.message || "請稍後再試")
    throw error
  }
}

const getAllApplyNo = async () => {
  try {
    const response = await $api(`/tca/expenseReimbursement/getAllApplyNo`, {
      method: 'POST',
    });
    applyNoList.value = response.data
    return response.data
  } catch (error) {
    applyNoList.value = []
    popSwal('error', "getAllApplyNo取得失敗", error.message || "請稍後再試")
  }
}

const getAllImageByApplyNo = async (applyNo) => {
  if(!applyNo){
    popSwal('error', "請選擇申請單號", "")
    return
  }
  try {
    const response = await $api(`/tca/expenseReimbursement/getAllImageByApplyNo`, {
      method: 'POST',
      query: {
        applyNo: applyNo
      }
    });
    return response.data
  } catch (error) {
    popSwal('error', "getAllImageByApplyNo取得失敗", error.message || "請稍後再試")
  }
}

const setImgStatus = async (params) => {
  if(!params){
    popSwal('error', "請選擇圖片", "")
    return
  }
  try {
    const response = await $api(`/tca/expenseReimbursement/setImgStatus`, {
      method: 'POST',
      query: params
    });
    return response.data
  } catch (error) {
    popSwal('error', "setImgStatus取得失敗", error.message || "請稍後再試")
  }
}

// ---API---



onMounted(async () => {
  loading.value = true
  await changeApplyNo()
  loading.value = false
})

</script>
<style scoped>
.floating-icons {
  pointer-events: none;
  position: absolute;
  left: 0; right: 0; top: 0;
  width: 100%;
  height: 200px;
  z-index: 10;
}
.float-icon {
  position: absolute;
  bottom: 0;
  animation: float-up 2s ease-out forwards;
  opacity: 0.8;
}
@keyframes float-up {
  0% {
    transform: translateY(0) scale(1) rotate(-10deg);
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  100% {
    transform: translateY(-120px) scale(1.4) rotate(10deg);
    opacity: 0;
  }
}
.mt-2.text-center {
  position: relative;
}
</style>